import React from "react";
import { Link } from "react-router-dom";
import "../styles/TwentyTwentysixContent.css";

export default function MembershipPage() {
  return (
    <div className="twentytwentysix-content">
      <div className="twentytwentysix-content__container">
        <p className="twentytwentysix-content__eyebrow">The Mamahood</p>
        <h1 className="twentytwentysix-content__title">Membership</h1>
        <p className="twentytwentysix-content__copy">
          Two ways to belong: our free community for all moms, and The Mamahood Collective for women+ entrepreneurs. Choose what fits you.
        </p>
        <div className="twentytwentysix-content__cta-row">
          <Link to="/twentytwentysix" className="twentytwentysix-content__pill">Back to Home</Link>
        </div>

        <section className="twentytwentysix-content__section">
          <h2 className="twentytwentysix-content__subtitle">For all moms</h2>
          <p className="twentytwentysix-content__copy">
            Free membership includes chat groups, articles, podcasts, events, and resources for Bay Area mamas. You can always upgrade for more.
          </p>
          <Link to="/twentytwentysix/join" className="twentytwentysix-content__pill">Become a Member Today</Link>
        </section>

        <section className="twentytwentysix-content__section twentytwentysix-content__section--cream">
          <h2 className="twentytwentysix-content__subtitle">For women+ entrepreneurs</h2>
          <p className="twentytwentysix-content__copy">
            Join 800+ women+ entrepreneurs building sustainable businesses. The Mamahood Collective offers coaching, masterclasses, and a private network.
          </p>
          <Link to="/twentytwentysix/collective" className="twentytwentysix-content__pill">Join The Mamahood Collective</Link>
        </section>
      </div>
    </div>
  );
}
